import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Divider,
} from '@mui/material';
import StandardizedChip from '../../common/StandardizedChip';
import { getPolicyIcon, getComplianceLevel } from './utils';

/**
 * PolicyOverviewTab Component
 *
 * Displays policy overview information including policy details and compliance level.
 *
 * @param {Object} props
 * @param {Object} props.policy - Policy object
 */
function PolicyOverviewTab({ policy }) {
  const compliance = getComplianceLevel(policy.name);

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Policy Information
              </Typography>
              <TableContainer>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <strong>Name</strong>
                      </TableCell>
                      <TableCell>{policy.name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <strong>Version</strong>
                      </TableCell>
                      <TableCell>{policy.version}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <strong>Status</strong>
                      </TableCell>
                      <TableCell>
                        {policy.enabled ? (
                          <StandardizedChip label="Enabled" color="success" />
                        ) : (
                          <StandardizedChip label="Disabled" color="default" />
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <strong>Rule Count</strong>
                      </TableCell>
                      <TableCell>{policy.rule_count || 0}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <strong>Created</strong>
                      </TableCell>
                      <TableCell>
                        {new Date(policy.created_at).toLocaleDateString()}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Compliance Level
              </Typography>
              <Box display="flex" alignItems="center" mb={2}>
                <StandardizedChip
                  label={compliance.level}
                  color={compliance.color}
                  icon={getPolicyIcon(policy.name)}
                  width={100}
                  sx={{ mr: 2 }}
                />
              </Box>
              <Typography variant="body2" color="text.secondary">
                {compliance.description}
              </Typography>
              <Divider sx={{ my: 2 }} />
              <Typography variant="body2">
                <strong>Description:</strong> {policy.description}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

export default PolicyOverviewTab;
